import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { invalidateProgramBroadcastWindow } from './invalidate-program-broadcast-window';

export function deleteBroadcastScheduleProgramSegment({
  id,
  action,
}: {
  id: string;
  action: 'first' | 'last';
}): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/program_broadcasts/${id}/segments/${action}`);
}

type MutationFn = typeof deleteBroadcastScheduleProgramSegment;

type TUseDeleteBroadcastScheduleProgramSegmentParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteBroadcastScheduleProgramSegment({
  config = {},
}: TUseDeleteBroadcastScheduleProgramSegmentParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteBroadcastScheduleProgramSegment,
    onError(error, variables, context) {
      config.onError?.(error, variables, context);
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El segmento del programa no se ha encontrado');
      }
      addErrorNotification('No se ha podido eliminar el segmento del programa');
    },
    onSuccess(data, variables, context) {
      config.onSuccess?.(data, variables, context);
      addSuccessNotification('El segmento del programa se ha eliminado correctamente');

      invalidateProgramBroadcastWindow(variables.id);
    },
  });
}
